import { commandApi } from '../commandApi';
import { ParentShareReviewProcessToggleError } from '../../admin/utils/errors/ParentShareReviewProcessToggleError';

const GET_PARENT_SHARE_RELEASE_STATE_COMMAND = '2bap:get-parent-share-release-state';
const RELEASE_PARENT_SHARE_OBSERVATIONS_COMMAND = '2bap:release-parent-share-observations';

// admin
const UPDATE_PARENT_SHARE_REVIEW_PROCESS_STATE_COMMAND = '2bap:set-parent-share-review-process';

class ParentShareApi {
  
  /**
   * @param {ObservationForReleaseLearnerListRequestModel} model
   * @return {Promise<*>}
   */
  async getParentShareLearnersReleaseState(model) {
    return commandApi.send(GET_PARENT_SHARE_RELEASE_STATE_COMMAND, model);
  }
  
  /**
   * @param {ReleaseObservationsRequestModel} model
   * @return {Promise<*>}
   */
  async releaseParentShareObservations(model) {
    return commandApi.send(RELEASE_PARENT_SHARE_OBSERVATIONS_COMMAND, model);
  }
  
  /**
   * @throws ParentShareReviewProcessToggleError
   * @param parentShareReviewProcessEnabled
   * @param ignoreUnreleasedObservations
   * @return {Promise<void>}
   */
  async updateParentShareReviewProcessState(parentShareReviewProcessEnabled, ignoreUnreleasedObservations) {
    try {
      const response = await commandApi.send(UPDATE_PARENT_SHARE_REVIEW_PROCESS_STATE_COMMAND,
        {
          parentShareReviewProcessEnabled,
          ignoreUnreleasedObservations
        });
      return response;
    } catch (error) {
      throw new ParentShareReviewProcessToggleError(error);
    }
  }
  
}
export const parentShareApi = new ParentShareApi();
